import React, { PureComponent } from "react";
import { Select } from 'element-react';
import { Link } from "react-router-dom";
import "../home/index.scss";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
export default class Index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            bmFwData: {}

        };
    }

    componentDidMount = () => {
        //便民服务
        Http.get(Request.get_Bm_Ts(), { pid: '1398602028008448001', current: 1, size: 10 }, obj => {
            if (obj.code == 200) {
                this.setState({
                    bmFwData: obj.data.records
                })
            }
        });
    }

    render() {
        const { bmFwData } = this.state;

        return (
            <div className="index-mains" style={{ backgroundColor: '#fff' }}>
                <div className="convenience">
                    <div className="index-header">
                        <div className="title">便民服务</div>
                    </div>
                    <div className="convenience-wrapper">
                        <div className="c-main">
                            {bmFwData && bmFwData.length > 0 ? bmFwData.map((item, i) => {
                                return (
                                    <div className="c-box" key={i}>
                                        <Link
                                            to={{ pathname: item.address, state: { id: item.id } }}
                                        >
                                            <div className="c-icon">
                                                <img src={item.bannerUrl} alt="" height="100%" />
                                            </div>
                                            <div className="c-title">{item.bannerTitle}</div>

                                        </Link>

                                    </div>
                                )
                            }) : <div className="placeholder"></div>}
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}
